module.exports = __webpack_public_path__ + "static/img/210_TO8_2142.6dc7740.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/210_TO8_2142.jpg
// module id = BsOw
// module chunks = 0